import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Global } from 'src/app/global/global';
import { WrapperStandardFilter, WrapperStandardRequest, WrapperStandardResponse } from '../../common/models/wrapper.model';
import { BaseMatTable } from './base-mat-table';


export class GenericListViewProperties<T> extends BaseMatTable<T> {

    //private _listViewDataSource: Array<T>;
    //private _listViewDataSourceURL: string;
    //private _requestData: any;
    private _requestData: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();
    //private carray_MatTableDataSource: Array<{}> = [];
    private _listViewDataSource: Array<T> = [];

    private _lineItemrequestData: WrapperStandardRequest<any> = new WrapperStandardRequest<any>();
    private _lineItemDataSource: Array<T> = [];
    private _lineItemDataSourceURL: string = "";
    private _displayedColumnsNames: Array<string> = [];
    private _paginatorPageLength: number = 0;
    private _paginatorPageIndex: number = 0;
    private _paginatorPageSize: number = 0;
    private _paginatorPageSizeOptions: Array<number> = [10, 20, 40, 50];
    public _filterArray: Array<WrapperStandardFilter> = new Array<WrapperStandardFilter>();

    public selectedFilterList: any = [];

    private _listViewDataSourceURL: string = "";
    //private cstr_PopulateListDataURL: string = "";
    private _routeTo: string = "";

    private _formTitle: string = "";
    private _formSubTitle: string = "";

    private _menuCode: string = "";
    private _appendDataSource: boolean = false;

    //Scroll Pagination
    private _listViewDataSourceForScrollPagination: Array<T> = [];
    private isPagination: boolean = true;
    private _listViewDataSourceForCFLChild: Array<T> = [];
    private _currentPage: number = 0;
    private _pageRecordCount: number = 0;
    private _pageSize: number = 0;
    private _rowCount: number = 0;
    private _wrapperStandardResponse: any;

    constructor() {

        super();
        //this._listViewDataSource = Array<T>();
        this._listViewDataSourceURL = "";
        //this.setMatTableDataSource = Array<{}>();
        this.setListViewDataSource = Array<T>();
        this.setPaginatorPageSize = 0;
        this.setPaginatorPageLength = 0;
        this.setPaginatorPageIndex = 0;
        this.setRequestData = new WrapperStandardRequest<any>();
    };

    // get getListViewDS(): Array<T> {
    //     return this._listViewDataSource;
    // };

    // set setListViewDS(value: Array<T>) {
    //     this._listViewDataSource = value;
    // };

    // get getListViewPoupulateURL(): string {
    //     return this._listViewDataSourceURL;
    // };

    // set setListViewPopulateURL(value: string) {
    //     this._listViewDataSourceURL = value;
    // };

    /*
    get getRequestData(): any {
        return this._requestData;
    };

    set setRequestData(value: any) {
        this._requestData = value;
    };
*/
    get getRequestData(): WrapperStandardRequest<any> {
        return this._requestData;
    };


    set setRequestData(value: WrapperStandardRequest<any>) {
        this._requestData = value;
    };


    //Properties Declarations

    public get getListViewDataSource(): Array<T> {
        return this._listViewDataSource;
    };

    public set setListViewDataSource(value: Array<T>) {
        if (this.getAppendDataSource) {
            // this._listViewDataSource.concat(value);
            this._listViewDataSource.push(...value);
            this.setAppendDataSource = false;
        } else {
            this._listViewDataSource = value;
        }
    };

    public get getDisplayedColumnsNamesList(): Array<string> {
        return this._displayedColumnsNames;
    };

    public set setDisplayedColumnsNamesList(value: Array<string>) {
        this._displayedColumnsNames = value;
    };

    public get getPaginatorPageLength(): number {
        return this._paginatorPageLength;
    };

    public set setPaginatorPageLength(value: number) {
        this._paginatorPageLength = value;
    };

    public get getPaginatorPageIndex(): number {
        return this._paginatorPageIndex;
    };

    public set setPaginatorPageIndex(value: number) {
        this._paginatorPageIndex = value;
    };

    public get getPaginatorPageSize(): number {
        return this._paginatorPageSize;
    };

    public set setPaginatorPageSize(value: number) {
        this._paginatorPageSize = value;
    };

    public get getPaginatorPageSizeOptions(): Array<number> {
        return this._paginatorPageSizeOptions;
    };

    public set setPaginatorPageSizeOptions(value: Array<number>) {
        this._paginatorPageSizeOptions = value;
    };

    public set setEntryFormRouteTo(value: string) {
        this._routeTo = Global.getRouteEForms.concat(value);
    };
    public get getEntryFormRouteTo() {
        return this._routeTo;
    };

    public get getListViewDataSourceURL(): string {
        return this._listViewDataSourceURL;
    };

    public set setListViewDataSourceURL(value: string) {
        this._listViewDataSourceURL = Global.getApiUrl.concat(value);
    };

    public get getFormTitle(): string {
        return this._formTitle;
    };

    public set setFormTitle(value: string) {
        this._formTitle = value;
    };

    public get getFormSubTitle(): string {
        return this._formSubTitle;
    };

    public set setFormSubTitle(value: string) {
        this._formSubTitle = value;
    };

    public get getMenuCode(): string {
        return this._menuCode;
    };

    public set setMenuCode(value: string) {
        this._menuCode = value;
    };

    public set 'setFilterArray'(value: WrapperStandardFilter) {
        this._filterArray.push(value);
        this.getRequestData.RequestData = this._filterArray;
    };

    public set setFilterArrCustom(value: Array<WrapperStandardFilter>) {

        this._filterArray = value;
    };

    public get getFilterArray(): Array<WrapperStandardFilter> {

        return this._filterArray;
    };

    get selectedFilters(): any {
        return this.selectedFilterList;
    }

    public set setAppendDataSource(value: boolean) {
        this._appendDataSource = value;
    };
    public get getAppendDataSource(): boolean {
        return this._appendDataSource;
    };


    //Scroll Pagination
    public get getListViewDataSourceOnScrollPagination(): Array<T> {
        return this._listViewDataSourceForScrollPagination;
    };
    public set setListViewDataSourceOnScrollPagination(value: Array<T>) {
        if (value.length == 0) {
            this._listViewDataSourceForScrollPagination = [];
        }
        this.getIsPagination ? this._listViewDataSourceForScrollPagination.push(...value)
            : this._listViewDataSourceForScrollPagination = value;
    };

    public get getIsPagination(): boolean {
        return this.isPagination
    };

    public set setIsPagination(isPagination: boolean) {
        this.isPagination = isPagination;
    };

    public get getCurrentPage(): number {
        return this._currentPage;
    };
    public set setCurrentPage(value: number) {
        this._currentPage = value;
    };
    public get getPageRecordCount(): number {
        return this._pageRecordCount;
    };
    public set setPageRecordCount(value: number) {
        this._pageRecordCount = value;
    };
    public get getPageSize(): number {
        return this._pageSize;
    };
    public set setPageSize(value: number) {
        this._pageSize = value;
    };
    public get getRowCount(): number {
        return this._rowCount;
    };
    public set setRowCount(value: number) {
        this._rowCount = value;
    };

    //Route Navigation
    private _objectType: string = "";

    public get getObjectType(): string {
        return this._objectType;
    }
    public set setObjectType(value: string) {
        this._objectType = value;
    };

    public set setLineItemDataSourceURL(value: string) {
        this._lineItemDataSourceURL = Global.getApiUrl.concat(value);
    };

    public get getLineItemDataSourceURL(): string {
        return this._lineItemDataSourceURL;
    };

    get getLineItemRequestData(): WrapperStandardRequest<any> {
        return this._lineItemrequestData;
    };

    set setLineItemRequestData(value: WrapperStandardRequest<any>) {
        this._lineItemrequestData = value;
    };

    public set setLineItemData(value: Array<T>) {
        this._lineItemDataSource = value;
    };

    public get getLineItemData(): any {
        return this._lineItemDataSource;
    };

   
}
